
import { defineComponent, PropType } from 'vue';
import { RouteLocation } from 'vue-router';

export default defineComponent({
  name: 'CardFullImg',
  props: {
    imgUrl: {
      type: String,
      required: false,
      default: null
    },
    accessibilityDescription: {
      type: String,
      required: false,
      default: null
    },
    heading: {
      type: String,
      required: false,
      default: null
    },
    routeLocation: {
      type: Object as PropType<RouteLocation>,
      required: false,
      default: null
    },
    onNavigate: {
      type: Function,
      required: false,
      default: () => null
    }
  },
  data() {
    return {
      paddingHeight: 0
    };
  }
});
